<template>
  <div>
    <div class="d-flex align-center justify-space-between mb-2">
      <p class="text-grey text-body-2 font-weight-regular text-uppercase mx-2">
        {{ t("onboarding.site.review.devices_section_label") }}
      </p>
      <span
        v-if="hasGoTo && canEdit"
        class="cursor-pointer text-grey text-body-2 font-weight-regular mx-2 text-decoration-underline"
        @click="emit('goTo')"
      >
        {{ t("form.edit") }}
      </span>
    </div>
    <div class="py-7 px-6 px-lg-11 rounded-xl elevation-1 bg-background">
      <p
        v-if="deviceBasket?.s1f2 || deviceBasket?.s1f2Dock"
        class="text-body-1 font-weight-regular"
      >
        {{ t("onboarding.site.review.s1f2_label") }}
      </p>
      <v-row
        v-if="deviceBasket?.s1f2 || deviceBasket?.s1f2Dock"
        class="justify-space-between my-4"
        no-gutters
      >
        <v-col v-if="deviceBasket?.s1f2" cols="6">
          <v-chip
            color="purple-5"
            size="large"
            class="w-100 justify-center text-center text-body-2 font-weight-medium"
          >
            <span class="text-black"
              >{{ t("components.devicesSummary.devicesLabel") }}:
              {{ deviceBasket?.s1f2 ?? 0 }}</span
            >
          </v-chip>
        </v-col>
        <v-col v-if="deviceBasket?.s1f2Dock" cols="6">
          <v-chip
            color="purple-5"
            size="large"
            class="w-100 justify-center ml-1 text-center text-body-2 font-weight-medium"
          >
            <span class="text-black"
              >{{ t("components.devicesSummary.docksLabel") }}:
              {{ deviceBasket?.s1f2Dock ?? 0 }}</span
            >
          </v-chip>
        </v-col>
      </v-row>

      <p v-if="deviceBasket?.s1e2" class="text-body-1 font-weight-regular">
        {{ t("onboarding.site.review.s1e2_label") }}
      </p>
      <v-row v-if="deviceBasket?.s1e2" class="d-flex justify-space-between my-4" no-gutters>
        <v-col cols="6">
          <v-chip
            color="purple-5"
            size="large"
            class="w-100 justify-center text-center text-body-2 font-weight-medium"
          >
            <span class="text-black"
              >{{ t("components.devicesSummary.devicesLabel") }}:
              {{ deviceBasket?.s1e2 ?? 0 }}</span
            >
          </v-chip>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, getCurrentInstance } from "vue";
import { useI18n } from "vue-i18n";
import { DeviceBasket } from "@/store/onboarding";

const { t } = useI18n();

defineProps<{ deviceBasket: DeviceBasket; canEdit?: boolean }>();
const emit = defineEmits(["goTo"]);

const hasGoTo = computed(() => !!getCurrentInstance()?.vnode.props?.onGoTo);
</script>
